<template>
  <div class="case">
    <div class="case-title">
      <span class="case-title-text">安徽省合肥青年路小学教育集团黄河路小学一争取让每个孩子，都有机会做"小小科学家"</span>
    </div>
    <div class="case-line"></div>
    <div class="case-main">
      <div class="case-section">
        <p class="case-section__content">
          "数字化实验设备突破了传统实验的时空限制，使复杂的实验更容易开展，促进了跨学科融合与创新思维的培养。"学校科学老师沐璟玮在接收中国教育电视台采访时说道。
        </p>
        <p class="case-section__content">
          "之前学到的知识，比如声音、电路等等，在实验中变得更加真实，我印象更深刻了。"社团成员莫杨说道。
        </p>
      </div>
      
      <div class="case-images">
        <div class="case-image-placeholder" >
          <img src="@/assets/images/case/case1_1.png" alt="case1-1">
        </div>
        <div class="case-image-placeholder" >
          <img src="@/assets/images/case/case1_2.jpeg" alt="case1-2">
        </div>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">一、师资紧张、课时有限，科学实验如何有效落地</h3>
        <p class="case-section__content">
          从2020年创办以来，合肥市青年路小学教育集团黄河路小学一直高度重视科学教育，央馆AI科学实验室设备齐全、条件优越，但全校只有一位科学老师，常规课堂时间有限，怎么才能让每个孩子都充分参与到实验中来？如何让设备真正"转"起来，让实验走进孩子的日常学习，成为学校亟待破解的难题。
        </p>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">二、用"多一小时"的实验室社团课，撬动科学素养的飞跃</h3>
        <p class="case-section__content">
          沐璟玮老师依托央馆AI实验室，首次在校内开设实验室社团课程，结合课程标准及要求，围绕生命科学、物质科学、发明创造、AI等7大课程主题，进行实验教学。每次1小时的社团课，不仅可以保证学生可以亲手操作传感器等精密设备，用更高精度的数据来验证知识；更确保课堂节奏不再局限于"讲完就下课"，而是以探究为主线，让孩子在一次次动手、一次次试错中，真正理解科学原理、形成科学思维。
        </p>
        <div class="case-images">
          <div class="case-image-placeholder" >
            <img src="@/assets/images/case/case1_3.jpeg"  alt="case1-3">
          </div>
          <div class="case-image-placeholder" >
            <img src="@/assets/images/case/case1_4.jpeg" alt="case1-4">
          </div>
        </div>
      </div>

      <div class="case-section">
        <h3 class="case-section__title">三、实验精神已萌芽，探索精神被"点亮"</h3>
        <p class="case-section__content">
          目前通过实验室社团的持续开展，央馆AI科学实验室从"好设备"变成"好课堂"——仪器频繁被使用，数据不再停在说明书上，而是出现在每个孩子的实验记录里。
        </p>
        <p class="case-section__content">
          学生在一次次操作中，科学探究能力显著提升——敢提问、会设计实验、能读懂数据，更愿意在失败中寻找原因，真正形成了从小培养的"实验精神"。
        </p>
        <p class="case-section__content">
          家长口碑与参与度同步上升，家校形成合力，科学教育从"学校有心""老师用心"，发展为"家庭支持""社会认可"。
        </p>
        <p class="case-section__content">
          六年级李思琪同学的家长甚至向学校提出希望在校园开放日中，组织家长观摩会，集体观看社团成果。
        </p>
        <p class="case-section__content">
          "孩子们回家说的'摸得着、量得出、看得见'的科学成果，希望我们家长有机会也可以看一看。"学生家长说道。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Case1"
}
</script>
<style lang="scss" scoped>
.case {
  width: 1185px;
  margin: 0 auto;
  background: #FFFFFF;
  padding: 32px;
  
  &-title {
    font-size: 24px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: normal;
    color: #262626;
  }
  
  &-line {
    width: 1120px;
    height: 1px;
    margin: 32px auto;
    background: #E5E5E5;
  }
  
  &-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  &-images {
    display: flex;
    gap: 20px;
    margin: 16px 0;
  }
  
  &-image-placeholder {
    flex: 0 0 auto;
    height: 300px;
    min-width: 0;
    background: #F5F5F5;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  &-section {
    display: flex;
    flex-direction: column;
    gap: 16px;

   
    
    &__title {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: #262626;
      margin: 0;
    }
    
    &__content {
      font-size: 16px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: #262626;
    }
  }
}
</style>
